import { Box, Table, useTable } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDiagramVenn,
  faBuildingCircleArrowRight,
} from '@fortawesome/pro-regular-svg-icons';
import { Grid } from '@material-ui/core';

import CampaignsByCspsListingRow from './CampaignsByCspsListingRow';
import CampaignsByPrimaryDcasListingRow from './CampaignsByPrimaryDcasListingRow';
import DashboardCount from './DashboardCount';
import { globalGetService } from '../../../utils/globalApiServices';

const byCspsHeadRows = [
  {
    id: 'cspName',
    label: 'CSP DBA NAME',
    sortable: false,
  },
  {
    id: 'usecase',
    label: 'USECASE',
    sortable: false,
  },
  {
    id: 'uid',
    label: 'CAMPAIGN ID',
    sortable: false,
  },
  {
    id: 'brandUid',
    label: 'BRAND ID',
    sortable: false,
  },
  {
    id: 'sharedOnDate',
    label: 'SHARED WITH ME ON',
    sortable: false,
  },
];

const byPrimaryDcaHeadRows = [
  {
    id: 'primaryDcaName',
    label: 'PRIMARY DCA',
    sortable: false,
  },
  {
    id: 'mnoName',
    label: 'ELECTED FOR MNO',
    sortable: false,
  },
  {
    id: 'uid',
    label: 'CAMPAIGN ID',
    sortable: false,
  },
  {
    id: 'brandUid',
    label: 'BRAND ID',
    sortable: false,
  },
  {
    id: 'sharedOnDate',
    label: 'SHARED WITH ME ON',
    sortable: false,
  },
];

export default function DashboardBlk(props) {
  const { title, img, type = '' } = props;
  const isPrimaryDca = type === 'primaryDca';

  const table = useTable(
    async (filter) => {
      const PAGE_SIZE = 10;
      const query = { ...filter, status: 'ACTIVE', recordsPerPage: PAGE_SIZE };
      const response = isPrimaryDca
        ? await fetchCampaignsAsPrimaryDcaApi(query)
        : await fetchCampaignsAsSecondaryDcaApi(query);
      return {
        data: response.records || [],
        rowsPerPage: response.recordsPerPage || PAGE_SIZE,
        total: response.totalRecords || 0,
        page: 1,
      };
    },
    {
      deps: [isPrimaryDca],
      defaultFilter: {
        sortField: isPrimaryDca ? 'id' : 'createDate',
        ascendingOrder: false,
      },
      inMemory: true,
    }
  );

  const fetchCampaignsAsPrimaryDcaApi = async (query = {}) => {
    return globalGetService(`dca/campaigns/primaryDca`, {
      ...query,
      sharingStatus: 'PENDING,ACCEPTED',
    }).then((response) => (response?.ok ? response.data : null));
  };
  const fetchCampaignsAsSecondaryDcaApi = async (query = {}) => {
    return globalGetService(`dca/campaigns/secondaryDca`, query).then(
      (response) => (response?.ok ? response.data : null)
    );
  };

  return (
    <div
      className={`dashboard-${
        isPrimaryDca ? 'sharedByCsps' : 'primaryDca'
      } block-wrapper`}
      data-testid="dashboardBlock"
      data-type={isPrimaryDca ? 'sharedByCsps' : 'primaryDca'}
    >
      <div className="title">
        <h3 className="heading2 text-center">
          <Box flexDirection="center" justifyContent="center">
            <Box margin={{ right: 'xs' }}>
              {isPrimaryDca ? (
                <FontAwesomeIcon icon={faBuildingCircleArrowRight} />
              ) : (
                <FontAwesomeIcon icon={faDiagramVenn} />
              )}
            </Box>
            <span>{title}</span>
          </Box>
        </h3>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <div style={{ height: 200, overflowY: 'auto' }}>
            <Table
              testId="dashboardTable"
              className="dashboard-campaigns-listing-table"
              disableHover
              headRows={isPrimaryDca ? byCspsHeadRows : byPrimaryDcaHeadRows}
              loading={table.loading}
              emptyState="no campaigns to view"
              filter={table.filter}
              tableData={table.tableData.map((campaign) =>
                isPrimaryDca ? (
                  <CampaignsByCspsListingRow
                    key={`CampaignsByCspsListingRow_${campaign.uid}`}
                    cspName={campaign.cspName}
                    usecase={campaign.usecase}
                    campaignUid={campaign.uid}
                    brandUid={campaign.brandUid}
                    sharedOnDate={campaign.sharedOnDate}
                    isRcs={campaign.channelId === 'RCS'}
                  />
                ) : (
                  <CampaignsByPrimaryDcasListingRow
                    key={`CampaignsByPrimaryDcasListingRow_${campaign.uid}`}
                    primaryDcaName={campaign.primaryDcaName}
                    mnoName={campaign.mnoList?.[0]?.name}
                    campaignUid={campaign.uid}
                    brandUid={campaign.brandUid}
                    sharedOnDate={campaign.sharedOnDate}
                    isRcs={campaign.channelId === 'RCS'}
                  />
                )
              )}
            />
          </div>
        </Grid>
        <Grid item xs={3}>
          <DashboardCount type={type} count={isPrimaryDca ? '' : table.total} />
        </Grid>
      </Grid>
    </div>
  );
}
